// extracted by mini-css-extract-plugin
module.exports = {"sideTabsSectionTitle":"SideTabsSectionTitle_sideTabsSectionTitle__n4zSe"};